import { useEffect } from "react";

import * as Sentry from "@sentry/react";

// Sentry is initialised before render in initSentry.ts. This hook tags events
// with the platform version once it is available from the app query.
export function useSentry(version: string) {
  useEffect(() => {
    if (version) {
      Sentry.setTag("platform.version", version);
    }
  }, [version]);
}
